import { IChatButtonType } from '../../interfaces/chat-button-interfaces';
import { chatChipNonVisblePages, inlineButtonChatPages } from '../../config/chat-config';
import { isHelpCenterHomepage } from './page-utils';
import { t } from '../translations';

let cachedLocaleConfig: Record<string, { chatbotEnabledPages: string[] }> | null = null;

export const fetchChatButtonConfig = async (): Promise<Record<string, { chatbotEnabledPages: string[] }> | null> => {
  if (cachedLocaleConfig) {
    return cachedLocaleConfig;
  }

  try {
    const response = await fetch('https://chat-anywhere.care.vpsvc.com/JS-build/chat-config.json');
    if (!response.ok) {
      console.warn('Failed to fetch chat config, allowing all pages');
      return {};
    }
    cachedLocaleConfig = await response.json();
    return cachedLocaleConfig;
  } catch (error) {
    console.error('Error fetching chat config:', error);
    return {};
  }
};

export const getButtonConfig = (customConfig?: { chatbotEnabledPages: string[] }): { enableChat: boolean; buttonType?: IChatButtonType } => {
  const pageURL = window.location.href;

  if (customConfig) {
    if (customConfig.chatbotEnabledPages.find((ele) => pageURL.includes(t(ele)))) {
      if (isHelpCenterHomepage()) {
        return { buttonType: 'hybrid', enableChat: true };
      }
      if (inlineButtonChatPages.find((ele) => pageURL.includes(t(ele)) && !pageURL.includes(t('my-account-projects')))) {
        return { buttonType: 'inline', enableChat: true };
      }
      return { enableChat: true, buttonType: 'floating' };
    } else {
      return { enableChat: false };
    }
  }
  if (chatChipNonVisblePages.find((ele) => pageURL.includes(t(ele)))) {
    return { enableChat: false };
  }
  if (isHelpCenterHomepage()) {
    return { buttonType: 'hybrid', enableChat: true };
  }
  if (inlineButtonChatPages.find((ele) => pageURL.includes(t(ele)) && !pageURL.includes(t('my-account-projects')))) {
    return { buttonType: 'inline', enableChat: true };
  }
  return { enableChat: true, buttonType: 'floating' };
};
